import React from "react";
import { useEffect } from "react";



const EmptyPage = ({ message, subMessage, buttonText, onButtonClick }) => {


  useEffect(() => {
    // Scroll to top smoothly when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  return (
    <div className="flex flex-col justify-between items-center font-poppins md:mb-[180px] mb-[200px] mt-20 md:mt-20">
      <div className="h-[131px] w-[400px] flex justify-center items-center">
        <p className="font-normal text-[16px] leading-[100%] tracking-[0%] text-center">
          {message} <br />
          {subMessage && <span className="mt-3 block">{subMessage}</span>}
        </p>
      </div>

      <div
        onClick={onButtonClick}
        className="inline-flex items-center justify-center gap-2 border border-primary-default px-10 py-4 mb-5 cursor-pointer hover:text-white transition-all duration-200"
      >
        <p className="font-semibold uppercase opacity-100 text-primary-default text-center whitespace-nowrap">
          {buttonText}
        </p>
      </div>
    </div>
  );
};

export default EmptyPage;
